export interface SalesPackEmailContacts {
  id: string;
  salesPackNo: string;
  emailDespatch: boolean;
  customerDespatchNoteEmailAddress: string;
  salesDespatchNoteContactEmailAddress: string;
}
